export const iconFontAwesomeTravelHotelMotorcycle = (
	<i className="fa-solid fa-motorcycle"></i>
);
